module.exports = __webpack_public_path__ + "static/media/phone.56f6b58b.svg";